import { VehicleManagement } from "@/components/VehicleManagement";

export default function VehiclesPage() {
  return <VehicleManagement />;
}


